import React, { useEffect, useState } from 'react';
import BaseCheckbox from 'components/atoms/base-checkbox';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

import s from './styles.module.scss';

interface IProps {
  label: string;
  value?: boolean;
  canPressNo?: boolean;
  tooltipMessage?: string;
  onCheck: (val: boolean) => void;
}

const ConsentFormCheckbox: React.FC<IProps> = (props) => {
  const { label, value, canPressNo = true, onCheck, tooltipMessage } = props;
  const [localState, setLocalState] = useState<boolean | undefined>(value);

  const { t } = useTranslation();

  const onChangeState = (state: boolean) => {
    setLocalState(state);
    onCheck(state);
  };

  useEffect(() => {
    if (typeof localState === 'undefined' && typeof value === 'boolean') {
      setLocalState(value);
    }
  }, [value]);

  return (
    <div className={s.flex}>
      {label}
      <BaseCheckbox
        value={localState === true}
        placeholder={t('labels.yes')}
        onChange={() => onChangeState(true)}
      />
      <Tooltip
        placement="top"
        trigger="hover"
        title={
          !canPressNo &&
          (tooltipMessage || t('messages.canNotUnconfirmedConsentForm'))
        }
      >
        <div>
          <BaseCheckbox
            value={localState === false}
            placeholder={t('labels.no')}
            onChange={() => onChangeState(false)}
            disabled={!canPressNo}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default ConsentFormCheckbox;
